import { render, staticRenderFns } from "./PropInsertDialog.vue?vue&type=template&id=766f724d&scoped=true&"
import script from "./PropInsertDialog.vue?vue&type=script&lang=js&"
export * from "./PropInsertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f724d",
  null
  
)

export default component.exports